import { PurchaseAreaDetailPage } from "@/features/purchase-area/pages/PurchaseAreaDetailPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/purchase-area/$id/detail")({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["purchase_area.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: PurchaseAreaDetailPage,
});
